module.exports = __webpack_public_path__ + "img/IMG-20180727-WA0032.3ee252d4.jpg";